import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  addLeadstageageing,
  getLeadstageageings,
  getLeadstageageing,
  editLeadstageageing,
  deleteLeadstageageing,
  getAllLeadstageageings,
} from "../../store/actions/leadstageageing_action";
import { SEARCH_TERMS } from "../enums/leadstageageings_enum";
// Get All Data
export const useAllLeadstageageings = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.leadstageageing);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
  const [q, setQ] = useState(null);
  const [term, setTerm] = useState(null);
  const [termField, setTermField] = useState(SEARCH_TERMS[0]);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  useEffect(() => {
    async function allQuery() {
      if (deleteEntry) {
        await dispatch(deleteLeadstageageing(deleteEntry));
      }
      if (term && term.length > 0) {
        setQ(term);
        dispatch(
          getLeadstageageings({
            termField: termField ? termField : termField,
            term: q ? q : "",
            pageNumber,
            start_from: dateFrom,
            start_to: dateTo,
          })
        );
      } else {
        dispatch(
          getLeadstageageings({
            termField: termField ? termField : termField,
            term: q ? q : "",
            pageNumber,
            start_from: dateFrom,
            start_to: dateTo,
          })
        );
      }
    }
    allQuery();
  }, [deleteEntry, term, pageNumber, dateFrom, dateTo]);
  useEffect(() => {
    setPageNumber(1);
  }, [term, dateTo, dateFrom]);

  const deleteBtnClicked = async (id) => {
    setDeleteEntry(id);
  };
  const resetFilter = () => {
    setPageNumber(1);
    setQ(null);
    setTerm("");
    setDateFrom("");
    setDateTo("");
    dispatch(getLeadstageageings({}));
  };

  return [
    data,
    pageNumber,
    setPageNumber,
    q,
    term,
    setTerm,
    termField,
    setTermField,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    deleteBtnClicked,
    resetFilter,
  ];
};

// Get Single Data
export const useSingleLeadstageageing = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.leadstageageing);
  useEffect(() => {
    dispatch(getLeadstageageing(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreateLeadstageageing = () => {
  const dispatch = useDispatch();
  const addData = async (data) => {
    await dispatch(addLeadstageageing(data));
  };
  return [addData];
};
export const useUpdateLeadstageageing = () => {
  const dispatch = useDispatch();
  const updateData = async (id, data) => {
    await dispatch(editLeadstageageing(id, data));
  };
  return [updateData];
};

export const useSelectAllLeadstageageing = () => {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.leadstageageing);
    useEffect(() => {
      dispatch(getAllLeadstageageings());
    }, []);
    return [data];
  };        